String.prototype.formataBr = function () {
  let fracao = "00";
  let numero = this.valueOf();
  numero = `${numero}`;
  if (numero.includes(".")) {
    [numero, fracao] = numero.split(".");
  }
  // Converte o número para uma string e inverte-a
  const numeroString = numero.toString().split("").reverse().join("");

  // Adiciona o ponto como separador de milhares a cada 3 dígitos
  const numeroFormatado = numeroString
    .replace(/(\d{3})/g, "$1.")
    .split("")
    .reverse()
    .join("");

  if (numeroFormatado[0].includes(".")) {
    return "" + numeroFormatado.substr(1) + "," + fracao;
  }

  // Adiciona a vírgula como separador decimal
  return "" + numeroFormatado + "," + fracao;
};

$(function () {
  // Sistema de pesquisa barra de valores

  // Valor mínimo e máximo da barra de preços
  var precoMinimo = 300;
  var precoMaximo = 4000;

  // Valor padrão da barra de preços
  var precoAtual = precoMinimo;

  // Saber se o mouse está sendo pressionado ou não
  var isDrag = false;

  var precoArr = [];

  // Função para arredondar o preço para o múltiplo de 50 mais próximo
  function arredondarParaMultiploDe50(valor) {
    return Math.round(valor / 50) * 50;
  }

  $(".pointer-barra").mousedown(function () {
    isDrag = true;
  });

  $(document).mouseup(function () {
    isDrag = false;
    enableTextSelection();
  });

  $(".barra-preco").mousemove(function (e) {
    if (isDrag) {
      disableTextSelection();
      var elBase = $(this);
      var mouseX = e.pageX - elBase.offset().left;

      // Garantir que o valor esteja dentro dos limites
      if (mouseX < 0) mouseX = 0;
      if (mouseX > elBase.width()) mouseX = elBase.width();

      // Calcular o novo preço com base na posição do mouse
      var novoPreco =
        (mouseX / elBase.width()) * (precoMaximo - precoMinimo) + precoMinimo;

      // Arredondar para o múltiplo de 50 mais próximo
      novoPreco = arredondarParaMultiploDe50(novoPreco);

      // Garantir que o novo preço não seja inferior ao preço mínimo
      if (novoPreco < precoMinimo) {
        novoPreco = precoMinimo;
      }

      // Atualizar o preço atual
      precoAtual = novoPreco;

      $(".pointer-barra").css("left", mouseX - 13 + "px");
      var percentual =
        ((precoAtual - precoMinimo) / (precoMaximo - precoMinimo)) * 100;
      $(".barra-preco-fill").css("width", percentual + "%");

      // Formatando o preço atual
      var precoFormatado = "R$" + precoAtual.toFixed(2).formataBr();
      if (precoAtual === 4000) {
        $(".preco_pesquisa").html("Acima de " + precoFormatado);
      } else if (precoAtual === precoMinimo) {
        $(".preco_pesquisa").html("Valor mínimo " + precoFormatado);
      } else {
        $(".preco_pesquisa").html(precoFormatado);
      }

      //Calulo de desconto
      let desconto = precoAtual * 0.3;
      let economia = desconto * 12;

      // Formatando o desconto
      let descontoFormatado = "R$" + desconto.toFixed(2).formataBr();
      let economiaFormatado = "R$" + economia.toFixed(2).formataBr();
      $(".desconto").html(descontoFormatado);
      $(".economia").html(economiaFormatado);

      $('input[name="desconto"]').val(descontoFormatado);
      $('input[name="00NbJ0000004QQY"]').val(precoFormatado);
    }
  });

  var precoFormatado = "R$" + precoAtual.toFixed(2).formataBr();

  //Calulo de desconto
  let desconto = precoAtual * 0.3;
  let economia = desconto * 12;

  // Formatando o desconto
  let descontoFormatado = "R$" + desconto.toFixed(2).formataBr();
  let economiaFormatado = "R$" + economia.toFixed(2).formataBr();
  $(".desconto").html(descontoFormatado);
  $(".economia").html(economiaFormatado);

  $('input[name="desconto"]').val(descontoFormatado);
  $('input[name="00NbJ0000004QQY"]').val(precoFormatado);

  function disableTextSelection() {
    $("body").css("-webkit-user-select", "none");
    $("body").css("-moz-user-select", "none");
    $("body").css("-ms-user-select", "none");
    $("body").css("-o-user-select", "none");
    $("body").css("user-select", "none");
  }

  function enableTextSelection() {
    $("body").css("-webkit-user-select", "auto");
    $("body").css("-moz-user-select", "auto");
    $("body").css("-ms-user-select", "auto");
    $("body").css("-o-user-select", "auto");
    $("body").css("user-select", "auto");
  }
});
